//
//
//
//

export default {
  name: "map",
  data() {
    return {
      deviceLocation: {

      }
    };
  },
  mounted() {
    this.deviceLocation = JSON.parse(this.$route.params.data);
    this.initMap(this.deviceLocation.lat,this.deviceLocation.lng,this.deviceLocation.name);
  },
  methods: {
    initMap(lat,lng,name) {
      // 定义地图中心点坐标
      // const center = new window.TMap.LatLng(37.464594, 121.447867);
      const center = new window.TMap.LatLng(lat, lng);
      // 定义map变量，调用 TMap.Map() 构造函数创建地图
      const map= new window.TMap.Map(document.getElementById('mapContainer'), {
        center: center, // 设置地图中心点坐标
        zoom: 15, // 设置地图缩放级别
        pitch: 20, // 设置俯仰角
        rotation: 0 // 设置地图旋转角度
      });
      new window.TMap.MultiMarker({
        map: map,
        //点标记数据数组
        geometries: [
          {
            id: '1', //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            styleId: 'myStyle', //指定样式id
            position: new window.TMap.LatLng(lat, lng), //点标记坐标位置
            properties: {
              //自定义属性
              title: name
            }
          }
        ]
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/map.vue